import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function ThemeList({ v }) {
  if (!v.showThemeList) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" onClick={v.closeThemeList} style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "98", "padding": "20px" }}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(640px,100%)", "maxHeight": "calc(100vh - 40px)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "13px", "boxSizing": "border-box", "overflow": "auto" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Alle thema's
              </div>
            </div>
            <button onClick={v.closeThemeList} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div style={{ "display": "grid", "gridTemplateColumns": "repeat(3, 1fr)", "columnGap": "6px", "rowGap": "1px" }}>
            {toList(v.themeList).map((t, $index) => (
              <React.Fragment key={$index}>
                <div style={css(t?.rowStyle)}>
                  {' '}
                  <span style={{ "fontSize": "11px", "fontWeight": "700", "color": "var(--tekst-3)", "flex": "0 0 18px", "textAlign": "right" }}>
                    <Interp v={t?.n} />
                  </span>
                  {' '}
                  <input value={t?.value ?? ''} onChange={t?.onInput} onBlur={t?.onBlur} placeholder="thema" style={css(v.themeInputStyle)} />
                  {' '}
                </div>
              </React.Fragment>
            ))}
          </div>
          {v.themeError ? (<>
            <div style={{ "fontSize": "12px", "fontWeight": "700", "color": "var(--fout)", "lineHeight": "1.4", "background": "var(--fout-vlak)", "border": "2px solid var(--fout-vlak)", "borderRadius": "12px", "padding": "10px 12px" }}>
              <Interp v={v.themeError} />
            </div>
          </>) : null}
          <button onClick={v.closeThemeList} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
